module.exports = __webpack_public_path__ + "img/jwgl-jcsj-zxsj.32595212.png";